import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getEntpExamConfigCurrent,
  exerciseDetails,
  submitPaperExercise
} from '@/apiCloud/examList'

import CameraDialog from "../../components/CameraDialog/CameraDialog.vue"

import Countdown from "@/components/Countdown";
let that;
let int;
Date.prototype.Format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;

};
export default {
  components: {
    myHeader,
    myFooter,
    CameraDialog,
    Countdown
  },
  data() {
    return {
      contentHeight: {
        height: ''
      },
      radio: [],
      recordId: "",
      examObj: {},
      oldExamObj: {},
      examDetail: {},
      answerSheetList: [],
      checkedCities: [],
      keepTime: "",
      userAnswerList: [],
      totalNum: 0,
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
      limitTime: "",
      isHint: false,
      beginDateTime: "",
      isLimitTime: false,
      activeName: '',
      isJx: false,
      imgUlrObj: "",
      imgUrl: "", // 拍摄的照片路径
      isPhoto: false, // 是否显示拍照
      dialogTableVisible: false, // 练习拍照弹框
      imgUlrList: [],
      timeStart: "",
      timeEnd: "",
      allTestTime: "",
      canUseTestTime: "",
      nowTime: "",
      config: {},
      testData: {
        exerciseId: null,
        courseId: null,
        timeStart: null,
        timeEnd: null,
        canAnyTimeExam: null,
        canLateDelay: null,
        passScore: null,
      },
      remainingTime: 0, //剩余时长(毫秒)
      countDownTimer: null, //结束时间倒计时定时器
      timeTips: [false, false], //剩余时间是否已提示，15分钟，5分钟
      beginDateTime1:''
    }
  },
  created() {
    that = this;
    that.testData = JSON.parse(localStorage.getItem("testData"))
    if (that.testData.timeStart) {
      that.timeStart = (that.testData.timeStart - 123456) / 3
      that.timeEnd = (that.testData.timeEnd - 123456) / 3
      that.allTestTime = ((that.timeEnd - that.timeStart) / 1000) / 60
      that.nowTime = Date.parse(new Date());
      that.canUseTestTime = Math.ceil(((that.timeEnd - that.nowTime) / 1000) / 60)
    }
    that.getConfig();
    setTimeout(function () {
      that.getCateExerciseList();
    }, 600)
    that.contentHeight.height = window.innerHeight - 250 + 'px';
    // var pUrl=window.location.href;
    //   // 是否是江西代理商访问
    //   if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //     // console.log(1111,this.isJx)
    //     this.isJx=true;
    //   }
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
  },
  watch: {
    // 监听剩余时间
    remainingTime(val) {
      if (val <= 900000 && !this.timeTips[0]) {
        // this.notifyWarning("考试剩余15分钟即将结束，请抓紧时间完成答题！");
        this.$confirm(
          "<p class='danger'>考试剩余15分钟即将结束，请抓紧时间完成答题！</p>",
          "提示", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "我知道了",
            showCancelButton: false,
            closeOnClickModal: false,
            type: "warning"
          }
        );
        this.timeTips[0] = true;
      }
      if (val <= 300000 && !this.timeTips[1]) {
        // this.notifyWarning("考试剩余5分钟即将结束，请抓紧时间完成答题！");
        this.$confirm(
          "<p class='danger'>考试剩余5分钟即将结束，请抓紧时间完成答题！</p>",
          "提示", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "我知道了",
            showCancelButton: false,
            closeOnClickModal: false,
            type: "warning"
          }
        );
        this.timeTips[1] = true;
      }
      if (val <= 0) {
        // this.$message({
        //   type: 'warning',
        //   message: '考试时间到，执行自动交卷！'
        // });
        let t = setTimeout(() => {
          // this.timer2();
          clearTimeout(t);
        }, 500);
      }
    }
  },
  methods: {
    // 结束时间倒计时
    countDown() {
      this.countDownTimer = setInterval(() => {
        if (this.remainingTime > 1000) {
          this.remainingTime -= 1000;
        } else {
          this.remainingTime = 0;
          clearTimeout(this.countDownTimer);
        }
      }, 1000);
    },
    //清除定时器
    clearFaTimer() {
      console.log("？？？")
    },
    // 获取配置信息(是否需要拍照)
    getConfig() {
      let data = {
        exerciseId: this.testData.exerciseId
      };
      getEntpExamConfigCurrent(data).then(res => {
        if (res.code == 200) {
          this.config = res.data;
          if (this.config.needPhoto == 0) {
            this.isPhoto = true;
            that.dialogTableVisible = true
          } else {
            this.isPhoto = false;
          }
        } else {

        }
      })
    },
    //练习详情
    getCateExerciseList() {
      let data = {
        exerciseId: this.testData.exerciseId
      };
      exerciseDetails(data).then(res => {
        if (res.code == 200) {
          that.isLimitTime = res.data.isLimitTime;
          that.oldExamObj = res.data;
          that.recordId = res.data.paperEntity.paperId
          if (that.testData.canAnyTimeExam == 0) {
            that.limitTime = res.data.limitTime;
          } else if (that.testData.canAnyTimeExam == 1) {
            if (that.testData.canLateDelay == 0) {
              that.limitTime = res.data.limitTime;
            } else if (that.testData.canLateDelay == 1) {
              // that.limitTime = that.canUseTestTime;
              //如果可以用来考试的时间大于考试时间则用考试时间
              if (that.canUseTestTime >= res.data.limitTime) {
                that.limitTime = res.data.limitTime
              } else {
                that.limitTime = that.canUseTestTime
              }
            }
          } else {
            that.limitTime = res.data.limitTime;
          }
          // console.log("clh====limitTime2===>",that.limitTime)
          that.examObj = {};
          that.answerSheetList = [];
          that.examObj = JSON.parse(JSON.stringify(that.oldExamObj));
          var number = 0;
          that.examObj.paperEntity.paperAreaList.forEach((obj) => {
            obj.questionList.forEach((questionObj) => {
              number = number + 1;
              questionObj.number = number;
              var answerN = "";
              questionObj.questionAnswers.forEach((answersObj, index) => {
                switch (index) {
                  case 0:
                    answersObj.nName = "A";
                    break;
                  case 1:
                    answersObj.nName = "B";
                    break;
                  case 2:
                    answersObj.nName = "C";
                    break;
                  case 3:
                    answersObj.nName = "D";
                    break;
                  case 4:
                    answersObj.nName = "E";
                    break;
                  case 5:
                    answersObj.nName = "F";
                    break;
                  case 6:
                    answersObj.nName = "G";
                    break;
                }
                if (answersObj.isRight) {
                  if (answerN != "") {
                    answerN = answerN + "," + answersObj.nName
                  } else {
                    answerN = answerN + answersObj.nName
                  }

                }
              });
              questionObj.rightAnswerName = answerN;
            });
            that.answerSheetList.push({
              titleName: obj.paperAreaName,
              list: obj.questionList
            })
          });
          that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
          that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
          that.start();
          that.beginDateTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss");
          that.beginDateTime1 = (new Date()).getTime();

        } else {
          // console.log("clh=======>","error");
          this.$message.error(res.message)
        }
      })
    },
    clickAnswer(examDetail, detail) { //单选题 选择答案 examDetail:题目详情  detail:答案详情
      that.radio = [detail.id];
      /*循环答题卡,修改答题卡状态*/
      that.answerSheetList.forEach((answerSheetObj) => {
        answerSheetObj.list.forEach((obj) => {
          obj.questionAnswers.forEach((answersObj) => {
            if (answersObj.id == detail.id) {
              obj.isRight = detail.isRight;
              examDetail.isRightUser = detail.isRight;
              obj.answerId = detail.id;
            }
            if (examDetail.id == obj.id && answersObj.isRight) {
              obj.answerName = answersObj.nName;
              examDetail.answerName = answersObj.nName;
            }
          });

        })
      });

      var indexNext = 0;
      var isRight = false;
      var isExist = false;
      that.examObj.paperEntity.paperAreaList.forEach((obj) => {
        obj.questionList.forEach((questionObj, index) => {
          questionObj.questionAnswers.forEach((answersObj) => {
            if (answersObj.id == detail.id) {
              questionObj.isRight = detail.isRight;
              questionObj.answerId = detail.id;

              if (index == obj.questionList.length - 1) {
                indexNext = 0;
              } else {
                indexNext = index + 1;
              }
              isRight = detail.isRight;
            }
          });
          if (indexNext == index && isRight && that.examObj.exerciseType == "1") { //答对的话 默认跳转到下一题
            that.examDetail = questionObj;
            if (questionObj.isRight != undefined && questionObj.answerId != undefined) {
              that.examDetail.isDisabled = true;
              that.radio = [questionObj.answerId];
            } else {
              that.examDetail.isDisabled = false;
              that.radio = [];
            }
            isRight = false;
            isExist = true;
            that.activeName = "";
            return false;
          }
        });
      });
      if (!isExist && that.examObj.exerciseType == "1") {
        that.examDetail.isDisabled = true;
      }

    },
    checkboxAnswer(examDetail) { //多选题 选择答案 examDetail:题目详情  detail:答案详情
      that.activeName = "";
      that.checkedCities.sort(function (a, b) {
        return a - b;
      });
      var answerId = "";
      that.checkedCities.forEach(function (c) {
        answerId = answerId + c + ","
      });
      var answer = "";
      var answerN = "";
      var answerList = [];
      that.examObj.paperEntity.paperAreaList.forEach((obj) => {
        obj.questionList.forEach((questionObj, index) => {
          questionObj.questionAnswers.forEach((answersObj, index) => {
            if (examDetail.id == questionObj.id) {
              questionObj.answerId = answerId;
              if (answersObj.isRight) {
                answerList.push(answersObj.id);
                answerN = answerN + answersObj.nName + ","
              }
              if (index + 1 == questionObj.questionAnswers.length) {
                answerList.sort(function (a, b) {
                  return a - b;
                });
                answerList.forEach(function (t) {
                  answer = answer + t + ","
                });
                questionObj.answerName = answerN;
                if (answer == answerId) {
                  questionObj.isRight = true;
                  if (that.examObj.exerciseType == "1") {
                    {
                      that.nextQuestion();
                    }
                  }
                } else {
                  that.examDetail.isDisabled = true;
                  questionObj.isRight = false;
                  that.examDetail = questionObj;
                }
              }
            }
          });
        });
      });

    },
    clickAnswerSheet(detail) { //点击答题卡
      that.activeName = "";
      that.examDetail = detail;
      that.checkedCities = [];
      that.radio = [];
      var list = [];
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(detail.answerId);
      }
      if (detail.answerId != undefined && that.examObj.exerciseType == "1") {
        that.examDetail.isDisabled = true;
      }
    },
    onTopic() { //上一题
      that.activeName = "";
      if (that.examDetail.number == that.totalNum) {
        this.$message({
          type: 'warning',
          message: '注:该题已是试卷最后一题,请检查试卷是否都已做完'
        });
      } else {

      }
      that.checkedCities = [];
      that.radio = [];
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i != 0) {
              that.examDetail = that.answerSheetList[c].list[i - 1];
            } else {
              that.examDetail = that.answerSheetList[c - 1].list[that.answerSheetList[c - 1].list.length - 1];
            }

          }
        }
      }
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(that.examDetail.answerId);
      }
      if (that.examDetail.answerId != undefined && that.examObj.exerciseType == "1") {
        that.examDetail.isDisabled = true;
      }
    },
    nextQuestion() { //下一题
      that.activeName = "";
      if (that.examDetail.number == that.totalNum) {
        this.$message({
          type: 'warning',
          message: '注:该题已是试卷最后一题,请检查试卷是否都已做完'
        });
        that.examDetail.isDisabled = true;
        return false
      } else {

      }
      that.checkedCities = [];
      that.radio = [];

      var detail = {};
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i >= that.answerSheetList[c].list.length - 1) {
              detail = that.answerSheetList[c + 1].list[0];
            } else {
              detail = that.answerSheetList[c].list[i + 1];
            }

          }
        }
      }
      that.examDetail = detail;
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(that.examDetail.answerId);
      }
      if (that.examDetail.answerId != undefined) {
        that.examDetail.isDisabled = true;
      }
    },
    subPaper() { //交卷
      var totalTime = "";
      if (that.isLimitTime) {
        var residueTime = that.hour * 3600000 + that.minute * 60000 + that.second * 1000; //模拟考剩余时间
        var totleTime = that.limitTime * 60000; //考试总时间
        var availableTime = (totleTime - residueTime) / 60000;
        var hour = parseInt(availableTime / 60);
        var minute = parseInt(availableTime % 60);
        var second = (availableTime * 60) % 60;
        var hourObj = hour > 9 ? hour : "0" + hour;
        var minuteObj = minute > 9 ? minute : "0" + minute;
        var secondObj = second > 9 ? second : "0" + second;
        totalTime = hourObj + ':' + minuteObj + ':' + secondObj;
      } else {
        totalTime = that.keepTime;
      }
      this.$confirm('确定要交卷吗', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        var paramData = {
          "exerciseId": that.examObj.exerciseId,
          "score": 0,
          "beginDateTime": that.beginDateTime,
          "totalTime": totalTime,
          courseId: that.testData.courseId,
          paperId: that.examObj.paperEntity.paperId,
          // "endDateTime": (new Date()).Format("yyyy-MM-dd hh:mm:ss"),
          "endDateTime": new Date(that.beginDateTime1+(totleTime - residueTime)).Format("yyyy-MM-dd hh:mm:ss"),
          "exerciseAnswersList": [],
        };
        var score = 0;
        that.examObj.paperEntity.paperAreaList.forEach((obj) => {
          obj.questionList.forEach((questionObj) => {
            if (questionObj.isRight) {
              score = score + questionObj.score
            }
            paramData.exerciseAnswersList.push({
              "isRight": questionObj.isRight != undefined && questionObj.isRight ? questionObj.isRight : false,
              "answerName": questionObj.answerName ? questionObj.answerName : "",
              "answerId": questionObj.answerId ? questionObj.answerId.toString() : "",
              "questionId": questionObj.id,
              "paperAreaId": obj.id
            })
          });
        });
        that.examObj.totalTime = totalTime;
        that.examObj.beginDateTime = that.beginDateTime; //开始时间
        that.examObj.assignmentTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss") ; //交卷时间;
        paramData.score = score;
        if (that.imgUlrList.length != 0) {
          var resData = {
            paperJson: JSON.stringify(paramData),
            photoUrl: that.imgUlrList[0].url,
            resultShow: that.config.resultShow,
            detailShow: that.config.detailShow
          };
        } else {
          var resData = {
            paperJson: JSON.stringify(paramData),
            resultShow: that.config.resultShow,
            detailShow: that.config.detailShow,
            type: 0
          };
        }
        submitPaperExercise(resData).then(res => {
          if (res.code == 200) {
            sessionStorage.setItem("examObj", JSON.stringify(that.examObj));
            if (this.config.resultShow == 0) {
              if (this.config.detailShow == 2) {
                this.$router.push({
                  path: "/testResult"
                });
              } else {
                this.$router.push({
                  path: "/otherTestRerult",
                  query: {
                    detailShow: this.config.detailShow,
                    passScore: this.testData.passScore
                  }
                });
              }
            } else {
              this.$message({
                message: '很遗憾，该考试不出结果！',
                type: 'warning'
              });
              this.$router.push({
                path: "/testList"
              });
            }
          } else {
            this.$message.error(res.message)
          }
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    restart() { //重新开始
      this.$confirm('确定要重新开始吗', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        that.radio = [];
        that.examObj = {};
        that.answerSheetList = [];
        that.examObj = JSON.parse(JSON.stringify(that.oldExamObj));
        var number = 0;
        that.examObj.paperEntity.paperAreaList.forEach((obj) => {
          obj.questionList.forEach((questionObj) => {
            number = number + 1;
            questionObj.number = number;
            var answerN = "";
            questionObj.questionAnswers.forEach((answersObj, index) => {
              switch (index) {
                case 0:
                  answersObj.nName = "A";
                  break;
                case 1:
                  answersObj.nName = "B";
                  break;
                case 2:
                  answersObj.nName = "C";
                  break;
                case 3:
                  answersObj.nName = "D";
                  break;
                case 4:
                  answersObj.nName = "E";
                  break;
                case 5:
                  answersObj.nName = "F";
                  break;
                case 6:
                  answersObj.nName = "G";
                  break;
              }
              if (answersObj.isRight) {
                if (answerN != "") {
                  answerN = answerN + "," + answersObj.nName
                } else {
                  answerN = answerN + answersObj.nName
                }

              }
            });
            questionObj.rightAnswerName = answerN;
          });
          that.answerSheetList.push({
            titleName: obj.paperAreaName,
            list: obj.questionList
          })
        });
        that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
        that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
        that.start();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    timer() { //计时
      console.log("clh====timer=====>", that.keepTime);
      that.millisecond = that.millisecond + 50;
      that.second = that.second + 1;
      if (that.second >= 60) {
        that.second = 0;
        that.minute = that.minute + 1;
      }

      if (that.minute >= 60) {
        that.minute = 0;
        that.hour = that.hour + 1;
      }
      var hourObj = that.hour > 9 ? that.hour : "0" + that.hour;
      var minuteObj = that.minute > 9 ? that.minute : "0" + that.minute;
      var secondObj = that.second > 9 ? that.second : "0" + that.second;
      that.keepTime = hourObj + ':' + minuteObj + ':' + secondObj;
    },
    timer2() { //倒计时
      /*模拟考 减*/
      // console.log("clh===itmer2======>",that.keepTime);
      // if (that.hour == 0 && that.minute <= 15 && that.isLimitTime) {
      //   that.isHint = true;
      // }
      var totalTime = "";
      if (that.isLimitTime) {
        var residueTime = that.hour * 3600000 + that.minute * 60000 + that.second * 1000; //模拟考剩余时间
        var totleTime = that.limitTime * 60000; //考试总时间
        var availableTime = (totleTime - residueTime) / 60000;
        var hour = parseInt(availableTime / 60);
        var minute = parseInt(availableTime % 60);
        var second = (availableTime * 60) % 60;
        var hourObj = hour > 9 ? hour : "0" + hour;
        var minuteObj = minute > 9 ? minute : "0" + minute;
        var secondObj = second > 9 ? second : "0" + second;
        totalTime = hourObj + ':' + minuteObj + ':' + secondObj;
      } else {
        totalTime = that.keepTime;
      }

      // console.log(that.hour, that.minute, that.second, that.isLimitTime)
      if (that.hour === 0 && that.minute === 0 && that.second === 0 && that.isLimitTime) {
        window.clearInterval(int);
        this.$alert("考试时间已结束,已提交试卷", '提示', {
          confirmButtonText: '确定',
          callback: action => {
            var paramData = {
              "exerciseId": that.examObj.exerciseId,
              "score": 0,
              courseId: that.testData.courseId,
              paperId: that.examObj.paperEntity.paperId,
              "beginDateTime": that.beginDateTime,
              // "endDateTime": (new Date()).Format("yyyy-MM-dd hh:mm:ss"),
              "endDateTime": new Date(that.beginDateTime1+(totleTime - residueTime)).Format("yyyy-MM-dd hh:mm:ss"),
              "totalTime": totalTime,
              "exerciseAnswersList": [],
            };
            var score = 0;
            that.examObj.paperEntity.paperAreaList.forEach((obj) => {
              obj.questionList.forEach((questionObj) => {
                console.log("clh====>res", 10);
                if (questionObj.isRight) {
                  console.log("clh====>res", 20);
                  score = score + questionObj.score
                }
                console.log("clh====>res", 30);
                paramData.exerciseAnswersList.push({
                  "isRight": questionObj.isRight ? questionObj.isRight : false,
                  "answerName": questionObj.answerName ? questionObj.answerName : "",
                  "answerId": questionObj.answerId ? questionObj.answerId : "",
                  "questionId": questionObj.id
                })
                console.log("clh====>res", 40);
              });
              console.log("clh====>res", 50);
            });
            console.log("clh====>res", 60);
            that.examObj.totalTime = totalTime;
            that.examObj.beginDateTime = that.beginDateTime; //开始时间
            that.examObj.assignmentTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss"); //交卷时间
            paramData.score = score;
            let papej = paramData && JSON.stringify(paramData)
            let imgUrl = that.imgUlrList && that.imgUlrList.length > 0 ? that.imgUlrList[0].url : "";
            let data = {
              paperJson: papej,
              photoUrl: imgUrl,
              resultShow: that.config.resultShow,
              detailShow: that.config.detailShow,
              type: 0
            };
            submitPaperExercise(data).then(res => {
              if (res.code == 200) {
                sessionStorage.setItem("examObj", JSON.stringify(that.examObj));
                console.log('000', this.config.resultShow)
                if (this.config.resultShow == 0) {
                  if (this.config.detailShow == 2) {
                    this.$router.push({
                      path: "/testResult"
                    });
                  } else {
                    console.log("clh====>res", 4)
                    this.$router.push({
                      path: "/otherTestRerult",
                      query: {
                        detailShow: this.config.detailShow,
                        passScore: this.testData.passScore
                      }
                    });
                  }
                } else {
                  console.log("clh====>res", 5)
                  this.$router.push({
                    path: "/testList"
                  });
                }
              } else {
                this.$message.error(res.message)
              }
            });
          }
        });
      } else {
        that.second = that.second - 1;
      }
      if (that.second <= 0 && that.minute > 0) {
        that.second = 60;
        that.minute = that.minute - 1;
      }
      if (that.minute <= 0 && that.hour > 0) {
        that.minute = 60;
        that.hour = that.hour - 1;
      }
      var hourObj = that.hour > 9 ? that.hour : "0" + that.hour;
      var minuteObj = that.minute > 9 ? that.minute : "0" + that.minute;
      var secondObj = that.second > 9 ? that.second : "0" + that.second;
      that.keepTime = hourObj + ':' + minuteObj + ':' + secondObj;
      let remainingTime = that.limitTime * 60000;
      if (remainingTime < 900000) {
        this.timeTips[0] = true;
      }
      if (remainingTime < 300000) {
        this.timeTips[1] = true;
      }
      this.remainingTime = remainingTime;
      // 开启倒计时
      this.countDown();
    },
    //开始函数
    start() {
      that.hour = 0;
      that.minute = 0;
      that.second = 0; //初始化
      window.clearInterval(int);
      // console.log("clh======","start执行了")
      // console.log("clh======",that.limitTime);

      // if (that.limitTime !== undefined && that.limitTime !== "" && that.limitTime !== 0) {
      if (that.limitTime) {

        // console.log("clh======", "if执行了");
        if (that.limitTime > 60) {
          that.hour = parseInt(that.limitTime / 60);
          that.minute = that.limitTime % 60;
          if (that.hour > 1 && that.minute == 0) {
            that.hour = that.hour - 1;
            that.minute = 59;
          } else {
            that.minute = that.limitTime % 60 - 1;
          }

        } else {
          that.minute = that.limitTime > 0 ? that.limitTime - 1 : that.limitTime;
        }
        that.second = 60;

        int = setInterval(that.timer2, 1000); //每隔50毫秒执行一次timer函数
      } else {
        // console.log("clh======", "else执行了");
        int = setInterval(that.timer, 1000); //每隔50毫秒执行一次timer函数
      }
    },
    stop() {
      window.clearInterval(int);
    },
    handleClose(done) {
      if (this.imgUlrList.length == 0) {
        this.$message.error("请点击拍照，拍照打卡后再开始做题")
      } else {
        done()
      }
    },
    //返回上一页
    goBack() {
      this.$router.push({
        path: "/testList"
      });
    },
    photograph() {
      this.$refs.camera2.setImage();
    },
    startExam() {
      if (this.imgUlrList.length == 0) {
        this.$message.error("请点击拍照，拍照打卡后再开始做题")
      } else {
        this.dialogTableVisible = false;
      }
    },
    getUlr(imgUrl) {
      console.log(imgUrl, 'imgUrl');
      this.imgUlrList.push({
        url: imgUrl,
        type: 0
      }); //type=0抓拍  1手动拍摄
      this.imgUlrObj = "";
      this.imgUlrList.forEach(function (obj) {
        that.imgUlrObj = that.imgUlrObj + obj.url + ",";
      });
    },
    getUlr2(imgUrl) {
      console.log(imgUrl, 'imgUrl');
      var isExist = false;
      this.imgUlrList.forEach(function (obj) {
        if (obj.type == 1) {
          isExist = true;
          obj.url = imgUrl
        }
      });
      if (!isExist) {
        this.imgUlrList.push({
          url: imgUrl,
          type: 1
        }); //type=0抓拍  1手动拍摄
      }
      this.imgUlrObj = "";
      this.imgUlrList.forEach(function (obj) {
        that.imgUlrObj = that.imgUlrObj + obj.url + ",";
      });
    },
  },
  destroyed: function () {
    window.clearInterval(int);
  },
}



// WEBPACK FOOTER //
// ./src/pages/testDetail/testDetail.js